module.exports = __webpack_public_path__ + "static/brand3-8711866032247361be0114091e6639c8.png";